import { z } from "zod";

export const inviteMemberSchema = z
	.object({
		email: z
			.email()
			.transform((e) => e.toLowerCase())
			.optional(),
		user_id: z.uuid().optional(),
	})
	.refine((data) => data.email || data.user_id, {
		message: "Either email or user_id must be provided",
	});

export type InviteMemberPayload = z.infer<typeof inviteMemberSchema>;
